export default "assets/images/properties-mask-c3e3f60a.svg";